import { Heading5, Overline } from '@components/Texts/Texts';
import tw, { styled } from 'twin.macro';

export const PriceTextStyle = styled.div``;

export const PriceTextValue = styled(Heading5)`
  ${tw`text-light-medium`};
`;

export const PriceTextText = styled(Overline)`
  ${tw`text-light-low`};
`;
